"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HttpGateway = exports.ActivityTracking = exports.TransferResponse = exports.ServerInfo = void 0;
var constants_1 = require("../constants/constants");
var messages_1 = require("../constants/messages");
var helpers_1 = require("../helpers/helpers");
var HttpGatewayGlobals = /** @class */ (function () {
    function HttpGatewayGlobals() {
        /** Chunk size to use for uploads in bytes. Default: 2 MiB. */
        this.chunkSize = 2097152;
        /** The ID to use for HTTP Gateway needed DOM items */
        this.mainContainerId = 'aspera-httpgateway';
        /** The ID to use for the form container for forms */
        this.formContainerId = 'aspera-httpgateway-form-container';
        /** The ID to use for the download container */
        this.downloadsContainerId = 'aspera-httpgateway-downloads-container';
        /** Map of all forms currently in the container */
        this.formsAvailable = new Map();
        /** Map of form with files from drop events */
        this.formsFilesFromDrop = new Map();
        /** Map of folders with files from drop events */
        this.folderFiles = new Map();
        /** Indicates if running in software mode (no DOM) */
        this.softwareMode = false;
        /** Indicates if multiple server support should be used (will not lock out if gateway server is not working) */
        this.supportMultipleServers = false;
        /** Number of concurrent uploads to support */
        this.concurrentUploads = 3;
        /** Map of dropzones created by querySelector */
        this.dropzonesCreated = new Map();
    }
    /**
     * Add a form item to the form container for transferring if form already exists the existing one is returned
     *
     * @param id ID to use for the form reference
     */
    HttpGatewayGlobals.prototype.createOrUseForm = function (id) {
        if (this.formsAvailable.get(id)) {
            return this.formsAvailable.get(id);
        }
        var form = document.createElement('form');
        form.id = id;
        this.formsAvailable.set(id, form);
        this.formContainer.appendChild(form);
        return this.formsAvailable.get(id);
    };
    /**
     * Delete a form from the container by the ID
     *
     * @param id the form to delete
     */
    HttpGatewayGlobals.prototype.deleteFormFromContainer = function (id) {
        var foundForm = this.formsAvailable.get(id);
        this.formsFilesFromDrop.delete(id);
        if (foundForm) {
            this.formContainer.removeChild(foundForm);
            this.formsAvailable.delete(id);
        }
    };
    /**
     * Removes all forms from the Parent container
     */
    HttpGatewayGlobals.prototype.removeAllFormsFromContainer = function () {
        while (this.formContainer.firstChild) {
            this.formContainer.removeChild(this.formContainer.firstChild);
        }
    };
    /**
     * Get or create an array of Files to store drop events in
     *
     * @param id the form to associate the files with
     */
    HttpGatewayGlobals.prototype.getOrCreateFormFileListFromDrop = function (id) {
        if (!this.formsFilesFromDrop.get(id)) {
            this.formsFilesFromDrop.set(id, []);
        }
        return this.formsFilesFromDrop.get(id);
    };
    /**
     * Get or create an array of Folder data to store folder entries
     *
     * @param id the form to associate the folders with
     */
    HttpGatewayGlobals.prototype.getOrCreateFolderDataList = function (id) {
        if (!this.folderFiles.get(id)) {
            this.folderFiles.set(id, new Map());
        }
        return this.folderFiles.get(id);
    };
    /**
     * Setup HTTP Gateway SDK server and formContainer
     *
     * @param serverUrl URL to use for the server
     * @param softwareMode indicate if software mode is in use
     * @param supportMultipleServers indicate if multiple servers are supported
     */
    HttpGatewayGlobals.prototype.setUpServer = function (serverUrl, softwareMode, supportMultipleServers) {
        if (typeof serverUrl === 'string') {
            this.serverUrl = serverUrl;
        }
        this.softwareMode = !!softwareMode;
        this.supportMultipleServers = !!supportMultipleServers;
        if (!this.softwareMode) {
            if (!this.mainContainer) {
                this.mainContainer = document.createElement('div');
                this.mainContainer.id = this.mainContainerId;
                this.mainContainer.setAttribute('style', constants_1.hiddenStyleList);
                document.querySelector('body').appendChild(this.mainContainer);
            }
            if (!this.formContainer) {
                this.formsAvailable.clear();
                this.formContainer = document.createElement('div');
                this.formContainer.id = this.formContainerId;
                document.querySelector("#".concat(this.mainContainerId)).appendChild(this.formContainer);
            }
            if (!this.downloadsContainer) {
                this.downloadsContainer = document.createElement('div');
                this.downloadsContainer.id = this.downloadsContainerId;
                document.querySelector("#".concat(this.mainContainerId)).appendChild(this.downloadsContainer);
            }
        }
    };
    HttpGatewayGlobals.prototype.backupDownloadMethod = function (url) {
        window.alert(messages_1.messages.loadingDownload);
        window.location.href = url;
    };
    /**
     * Download a file based on a URL. By default a hidden IFRAME attempts to download
     * the file but if that fails a fallback of opening a new window happens.
     *
     * @param url the URL of the file to download
     */
    HttpGatewayGlobals.prototype.triggerDownloadFromUrl = function (url) {
        var _this = this;
        try {
            var element = document.createElement('iframe');
            element.src = url;
            element.onerror = function (error) {
                (0, helpers_1.errorLog)(messages_1.messages.failedToGenerateIframe, error);
                _this.backupDownloadMethod(url);
            };
            document.querySelector("#".concat(this.downloadsContainerId)).appendChild(element);
        }
        catch (error) {
            (0, helpers_1.errorLog)(messages_1.messages.failedToGenerateIframe, error);
            this.backupDownloadMethod(url);
        }
    };
    return HttpGatewayGlobals;
}());
var ServerInfo = /** @class */ (function () {
    function ServerInfo() {
    }
    return ServerInfo;
}());
exports.ServerInfo = ServerInfo;
var TransferResponse = /** @class */ (function () {
    function TransferResponse() {
    }
    return TransferResponse;
}());
exports.TransferResponse = TransferResponse;
var ActivityTracking = /** @class */ (function () {
    function ActivityTracking() {
        /** Map of transfers by ID */
        this.transfers = new Map();
        /** Map of callbacks that receive transfers */
        this.callbacks = new Map();
        /** Indicate if a callback should happen */
        this.needCallback = false;
        /** Queued uploads */
        this.queuedUploads = [];
        this.pollCallbacks();
    }
    /**
     * Get transfer response object including all transfers
     *
     * @returns transfer data object with transfers array
     */
    ActivityTracking.prototype.getAllTransfersResponse = function () {
        var transfers = this.getAllTransfers();
        return {
            iteration_token: '',
            result_count: transfers.length,
            transfers: transfers
        };
    };
    /**
     * Remove all transfers that are not active
     */
    ActivityTracking.prototype.clearNonActiveTransfers = function () {
        var _this = this;
        var transferIdsToRemove = this.getAllTransfers().filter(function (transfer) {
            return transfer.status === 'completed' || transfer.status === 'failed';
        }).map(function (transfer) { return transfer.uuid; });
        transferIdsToRemove.forEach(function (id) {
            _this.removeTransfer(id);
        });
    };
    /**
     * Poll transfer callbacks
     */
    ActivityTracking.prototype.pollCallbacks = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.needCallback) {
                _this.callbacks.forEach(function (value) {
                    if (typeof value === 'function') {
                        value(_this.getAllTransfersResponse());
                    }
                });
            }
            _this.needCallback = false;
            _this.pollCallbacks();
        }, 2000);
    };
    /**
     * Trigger activity callback on activity events
     */
    ActivityTracking.prototype.triggerActivityCallbacks = function () {
        this.needCallback = true;
    };
    /**
     * Register a callback for getting transfers back to the consumer
     *
     * @param callback the function to call with the array of transfers
     *
     * @returns the ID of the callback index
     */
    ActivityTracking.prototype.setCallback = function (callback) {
        if (typeof callback !== 'function') {
            (0, helpers_1.errorLog)(messages_1.messages.callbackIsNotFunction);
            return;
        }
        var id = "callback-".concat(this.callbacks.size + 1);
        this.callbacks.set(id, callback);
        return id;
    };
    /**
     * Remove the callback (deregister) from the list of callbacks
     *
     * @param id the string of the callback to remove
     */
    ActivityTracking.prototype.removeCallback = function (id) {
        this.callbacks.delete(id);
    };
    /**
     * Set the transfer in the transfers map
     *
     * @param id transfer id for tracking transfers
     * @param transfer transfer object
     */
    ActivityTracking.prototype.setTransfer = function (id, transfer) {
        this.transfers.set(id, transfer);
        this.triggerActivityCallbacks();
    };
    /**
     * Get the status of a specific transfer by ID (only returns for items during the session)
     *
     * @param id the ID of the transfer to retrieve that has been started during the session
     *
     * @returns an HttpTransfer object that includes the transfer info and status
     */
    ActivityTracking.prototype.getTransferById = function (id) {
        return this.transfers.get(id);
    };
    /**
     * Get all active transfers (transfers that are not completed or failed)
     */
    ActivityTracking.prototype.getActiveTransfers = function () {
        return (0, helpers_1.iterableToArray)(this.transfers.values()).filter(function (transfer) {
            return transfer.status !== 'completed' && transfer.status !== 'failed';
        });
    };
    /**
     * Remove a transfer from the transfer list
     *
     * @param id the ID of the transfer to remove
     */
    ActivityTracking.prototype.removeTransfer = function (id) {
        this.transfers.delete(id);
        this.triggerActivityCallbacks();
    };
    /**
     * Get the list of transfers started during the session for checking status
     *
     * @param returnMap boolean to indicate if the raw Map should be returned instead of an array
     *
     * @returns an Array of transfers or a Map of transfers (with the ID as key). Array is default
     */
    ActivityTracking.prototype.getAllTransfers = function (returnMap) {
        var transferList = [];
        var transferMap = new Map();
        this.transfers.forEach(function (value, key) {
            transferList.push(value);
            transferMap.set(key, value);
        });
        return returnMap ? transferMap : transferList;
    };
    return ActivityTracking;
}());
exports.ActivityTracking = ActivityTracking;
var HttpGateway = /** @class */ (function () {
    function HttpGateway() {
        var _this = this;
        /** Global information about the HTTP Gateway */
        this.globals = new HttpGatewayGlobals();
        /** Activity tracking for watching transfers */
        this.activityTracking = new ActivityTracking();
        /**
         * If the user attempts to leave the page warn that by leaving they will have their transfer abort
         * NOTE: Only IE will show custom text.  No way to indicate why they are being blocked.
         */
        this.checkForPageLeave = function (event) {
            if (_this.activityTracking.getActiveTransfers().length) {
                event.preventDefault();
                event.returnValue = messages_1.messages.leavingWhileUploading;
                return messages_1.messages.leavingWhileUploading;
            }
            else {
                delete event['returnValue'];
            }
        };
    }
    Object.defineProperty(HttpGateway.prototype, "isReady", {
        /**
         * Check if the HTTP Server is ready to be used and has been verified
         *
         * @returns a boolean indicating if SDK can be used for transfers
         */
        get: function () {
            return this.globals.serverVerified || this.globals.supportMultipleServers;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Overwrite default chunk size for chunking transfer data.
     * This is an optional function, a default recommended size is set on start.
     *
     * @param size the size to use
     */
    HttpGateway.prototype.overwriteDefaultChunkSize = function (size) {
        if (size && size > 0) {
            this.globals.chunkSize = size;
        }
        else {
            (0, helpers_1.errorLog)(messages_1.messages.invalidChunkSize, { requestedSize: size });
        }
    };
    /**
     * Overwrite default concurrent transfer number for parallel transfers
     * This is an optional function, a default recommended number is set on start.
     *
     * @param transfers the number of concurrent uploads to use
     */
    HttpGateway.prototype.overwriteDefaultConcurrentUploads = function (transfers) {
        if (transfers && transfers > 0) {
            this.globals.concurrentUploads = transfers;
        }
        else {
            (0, helpers_1.errorLog)(messages_1.messages.invalidConcurrentUploads, { requestedSize: transfers });
        }
    };
    return HttpGateway;
}());
exports.HttpGateway = HttpGateway;
